var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg6 = function Svg6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint0_linear_692_423027)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7764 23.1023C9.9708 23.1565 11.2057 26.4613 10.9168 27.5395C10.7751 28.0544 10.4123 28.4862 9.90772 28.7407C9.40309 28.9951 8.79759 29.0516 8.22345 28.8978C7.6493 28.744 7.15317 28.3923 6.84339 27.9196C6.53361 27.4469 6.43536 26.8915 6.5701 26.3749C6.85901 25.2966 9.58189 23.0481 9.7764 23.1023Z",
    fill: "#42A0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7764 23.1023C16.9708 23.1565 18.2057 26.4613 17.9168 27.5395C17.7751 28.0544 17.4123 28.4862 16.9077 28.7407C16.4031 28.9951 15.7976 29.0516 15.2234 28.8978C14.6493 28.744 14.1532 28.3923 13.8434 27.9196C13.5336 27.4469 13.4354 26.8915 13.5701 26.3749C13.859 25.2966 16.5819 23.0481 16.7764 23.1023Z",
    fill: "#42A0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5981 28.5141C24.3309 28.6706 24.0039 28.6064 23.8679 28.3708L23.112 27.1378L22.3109 28.3957C22.1587 28.6214 21.828 28.6626 21.5723 28.4877C21.3166 28.3128 21.2327 27.988 21.385 27.7623L22.1537 26.5552L20.4959 26.5553C20.224 26.5482 20.0101 26.2926 20.018 25.9844C20.026 25.6762 20.2528 25.4321 20.5247 25.4392L22.0706 25.4391L21.2461 24.0942C21.11 23.8585 21.2164 23.5407 21.4836 23.3842C21.7508 23.2277 22.0778 23.2918 22.2138 23.5275L23.1301 25.022L24.0823 23.5268C24.2345 23.3011 24.5652 23.2599 24.8209 23.4347C25.0766 23.6096 25.1605 23.9344 25.0082 24.1601L24.1939 25.4389L25.5397 25.4388C25.8116 25.4459 26.0255 25.7015 26.0176 26.0097C26.0096 26.3179 25.7828 26.562 25.5109 26.5549L24.0699 26.555L24.8356 27.8041C24.9717 28.0397 24.8653 28.3576 24.5981 28.5141Z",
    fill: "#42A0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_423027",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/6.d749f0b5.svg";
export { ForwardRef as ReactComponent };